module.exports = __webpack_public_path__ + "static/media/EEELR.d902f0e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EEELR.jpg
// module id = 1732
// module chunks = 1